/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Create_TitleInputs */

const cs_signing_create_title = /** @type {(inputs: Signing_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat dokument k podpisu`)
};

const en_signing_create_title = /** @type {(inputs: Signing_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send document for signing`)
};

/**
* | output |
* | --- |
* | "Send document for signing" |
*
* @param {Signing_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_create_title = /** @type {((inputs?: Signing_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_create_title(inputs)
	return cs_signing_create_title(inputs)
});